import * as React from 'react';
import { connect } from 'react-redux';
import SignIn from '../shared/Login';
import { remoteLogin } from './redux-objects/actions';
import { ILoginRequest } from './common/defaults';
import { Modal } from 'react-bootstrap';
import './assets/Login.scss';
// @ts-ignore
const bgImage = require('./assets/img/background.jpeg');
import * as urls from '../shared/urls';

export interface ILoginComponentProps {
	serviceURL: string;
	errorMessage: string;
	loggingIn: boolean;
	remoteLogin: (loginRequest: ILoginRequest, url: string) => void;
}

class LoginComponent extends React.Component<ILoginComponentProps> {
	signin = React.createRef<any>();

	attemptSignIn = (username: string, password: string) => {
		const loginReq: ILoginRequest = { Username: username, Password: password };
		// console.log('Made it to here.');
		this.props.remoteLogin(loginReq, this.props.serviceURL + urls.LOGIN_URL);
	};

	render() {
		return (
			<React.Fragment>
				<div className="bground">
					<img src={bgImage} width="100%" height="100%" alt="Background" />
				</div>
				<div className="container-fluid layout">
					<div className="row banner">
						<div className="col-lg-5 offset-lg-1 app-info">
							<h1 className="warning">Warning!</h1>
							<div className="card card-body bg-dark well">
								Membership is required and unauthorized access to this site is strictly prohibited.
								Unauthorized users or attempts to gain unauthorized access may be subject to criminal
								prosecution.
							</div>
							This website is developed and maintained by LexisNexis on behalf of the Nebraska Department
							of Transportation to serve as a portal into their crash repository.
						</div>
						<div className="col-lg-3 login offset-lg-2">
							<SignIn
								onSignIn={this.attemptSignIn}
								errorMessage={this.props.errorMessage}
								ref={this.signin}
							/>
						</div>
					</div>
				</div>
				<Modal
					dialogClassName=".modal-fullscreen"
					show={this.signin.current ? this.signin.current.state.loggingIn : false}
				>
					<Modal.Body>
						Logging in...
						<div
							className="spinner-grow ml-auto"
							style={{ position: 'absolute', right: '10px' }}
							aria-hidden="true"
						/>
					</Modal.Body>
				</Modal>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (reduxState: any) => {
	return {
		errorMessage: reduxState.Login.errorMessage,
		loggingIn: reduxState.Login.loggingIn,
		serviceURL: reduxState.Application.backendURL
	};
};

const mapDispatchToProps = {
	remoteLogin
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);
